export default __webpack_public_path__ + "static/media/darkzip.6fb8d394.svg";